module.exports = __webpack_public_path__ + "img/sbgl.png";